import {Component, ElementRef, OnInit, ViewChild, ChangeDetectorRef} from '@angular/core';
import {Router, ActivatedRoute} from "@angular/router";
import {DataService,Quote} from '../../../../services/commande-client/data.service';
import {ToastrService} from "ngx-toastr";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import flatpickr from "flatpickr";
import {French} from "flatpickr/dist/l10n/fr";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import {HeaderService} from "../../../../services/header/header.service";
import {EditWarehouseComponent} from "../../stock/gestionStock/edit-warehouse/edit-warehouse.component";
import {SaveComponent} from "./save/save.component";
import {TresorerieService} from "../../../../services/tresorerie/tresorerie.service";
import {Tresorerie} from '../../../../models/Tresorerie/Tresorerie';
import {TresorerieFilters} from '../../../../models/Tresorerie/TresorerieFilters';
import {Solde} from '../../../../models/Tresorerie/Solde';
import {CategorieTresorerie} from '../../../../models/Tresorerie/CategorieTresorerie';

@Component({
    selector: 'app-detail-tresorerie',
    templateUrl: './detail-tresorerie.component.html',
    styleUrls: ['./detail-tresorerie.component.scss']
})
export class DetailTresorerieComponent implements OnInit {
    @ViewChild('save') saveComponent!: SaveComponent;
    @ViewChild('exportContainer') exportContainer!: ElementRef;

    onOperationCreated() {
        this.loadSolde();
        this.loadOperations();
    }

    /** Supprime une opération de trésorerie via l'API DELETE /api/tresorerie/:id */
    deleteTresorerie(item: { id?: number; operation?: Tresorerie }): void {
        const id = item?.id ?? item?.operation?.id;
        if (id == null) {
            this.toastr.error('ID de l\'opération manquant', 'Erreur');
            return;
        }
        this.tresorerieService.deleteTresorerie(id).subscribe({
            next: () => {
                this.toastr.success('Opération de trésorerie supprimée', 'Succès');
                this.loadSolde();
                this.loadOperations();
            },
            error: (err) => {
                console.error('Erreur suppression trésorerie:', err);
                this.toastr.error(err?.error?.message || 'Erreur lors de la suppression', 'Erreur');
            }
        });
    }

    retour() {
        this.router.navigate(['/comptabilite/tresorerie']);
    }


    items: any[] = [];
    filteredData: Tresorerie[] = [];
    paginatedData: Tresorerie[] = [];
    searchTerm = '';
    showFilter = false;
    isLoading = false;
    stationId: number = 0;
    userId: number = 0;
    soldeType: string = 'secondaire';
    currentSolde: Solde | null = null;
    categories: CategorieTresorerie[] = [];
    private _activeFilters: Array<{key: string, label: string, value: string}> = [];

    basicSelectedOption = 10;
    currentPage = 1;
    totalPages = 1;
    pages: number[] = [];
    filterSummary = '';

    perPage = 10;
    pageOptions = [5, 10, 20, 50, 100];

    // Propriétés pour le filtrage de date (utilisées pour le filtrage côté client)
    dateFilterStart: string = '';
    dateFilterEnd: string = '';

    filters: TresorerieFilters = {
        dateFrom: '',
        dateTo: '',
        type_operation: '',
        type_transaction: '',
        methode_paiement: '',
        categorie_id: undefined,
        statut: '',
        station_id: undefined,
        search: '',
        solde_type: undefined
    };

    constructor(
        private toastr: ToastrService,
        private dataService: DataService,
        private router: Router,
        private route: ActivatedRoute,
        private headerService: HeaderService,
        private tresorerieService: TresorerieService,
        private cdr: ChangeDetectorRef
    ) {
    }

    ngOnInit() {
        this.loadUserData();
        this.loadCategories();

        // Ne pas initialiser les dates de filtre - toutes les données seront affichées par défaut
        this.dateFilterStart = '';
        this.dateFilterEnd = '';
        this.filters.dateFrom = '';
        this.filters.dateTo = '';

        this.route.queryParams.subscribe(params => {
            if (params['type']) {
                this.soldeType = String(params['type']);
            }
            this.dateFilterStart = '';
            this.dateFilterEnd = '';
            this.filters.dateFrom = '';
            this.filters.dateTo = '';
            this.loadSolde();
            this.loadOperations();
        });
    }

    private loadUserData(): void {
        try {
            const userJson = localStorage.getItem('currentUser');
            if (userJson) {
                const user = JSON.parse(userJson);
                this.userId = user?.id != null ? Number(user.id) : 0;
                const station = user?.stations?.[0];
                this.stationId = station?.id ? Number(station.id) : 0;
                this.filters.station_id = this.stationId;
            }
        } catch (error) {
            console.error('Erreur lors de la récupération des données utilisateur:', error);
            this.toastr.error('Erreur lors de la récupération des données utilisateur.', 'Erreur');
        }
    }

    /** Titre du bandeau (libellé du solde / caisse). */
    private soldeLibelleHeader(): string {
        const t = (this.currentSolde?.type_solde || this.soldeType || '').trim();
        return t || 'Solde';
    }

    /** Libellé pour exports XML / données. */
    private soldeTypeTitreForExport(): string {
        return (this.currentSolde?.type_solde || this.soldeType || 'Solde').trim();
    }

    /** Segment de nom de fichier (PDF / XML). */
    private soldeTypeSlugForFile(): string {
        const raw = (this.soldeType || 'solde').trim().toLowerCase();
        const slug = raw.replace(/\s+/g, '-').replace(/[^a-z0-9_-]/gi, '');
        return slug || 'solde';
    }

    private loadSolde(): void {
        if (!this.stationId || !this.userId) {
            return;
        }

        this.tresorerieService.getSoldesByStationAndUser(this.stationId, this.userId).subscribe({
            next: (soldes: Solde[]) => {
                const list = soldes || [];
                this.currentSolde = list.find((s) => s.type_solde === this.soldeType) || null;

                const soldeTitle = this.soldeLibelleHeader();
                const soldeValue = this.currentSolde ? parseFloat(this.currentSolde.montant_total || '0') : 0;

                console.log('💰 [DetailTresorerieComponent] Solde courant:', this.soldeType, '→', soldeValue);

        this.headerService.setConfig({
                    title: soldeTitle,
            buttons: [
                {
                    label: 'Exporter',
                    type: 'dropdown',
                    dropdownItems: [
                        {
                            label: 'PDF',
                            action: () => this.exportToPDF(),
                            icon: '../../../assets/images/logo/pdf_logo.png'
                        },
                        {
                            label: 'XML',
                            action: () => this.exportToXML(),
                            icon: '../../../assets/images/logo/xml.png'
                        }
                    ]
                },
                {
                            label: 'Enregistrer l\'opération',
                    action: () => this.openSaveModal(),
                    type: 'primary'
                        }
                    ]
                });
            },
            error: (error) => {
                console.error('❌ [DetailTresorerieComponent] Erreur lors du chargement du solde:', error);
            }
        });
    }

    private loadOperations(): void {
        if (!this.stationId) return;

        this.isLoading = true;
        this.filters.station_id = this.stationId;
        this.filters.solde_type = this.soldeType;

        if (!this.filters.dateFrom && !this.filters.dateTo) {
            console.log('📊 [DetailTresorerieComponent] Aucun filtre de date - Affichage de toutes les opérations');
        }

        console.log('📊 [DetailTresorerieComponent] Chargement des opérations avec filtres:', JSON.stringify(this.filters, null, 2));
        console.log('📊 [DetailTresorerieComponent] Type de solde:', this.soldeType);
        console.log('📊 [DetailTresorerieComponent] Filtres de date:', { dateFrom: this.filters.dateFrom, dateTo: this.filters.dateTo });


        let allOperations: Tresorerie[] = [];
        let currentPage = 1;
        const limit = 1000;

        const fetchPage = () => {

            const filtersWithPagination: TresorerieFilters = { ...this.filters };

            if (!filtersWithPagination.dateFrom || filtersWithPagination.dateFrom === '') {
                delete filtersWithPagination.dateFrom;
            }
            if (!filtersWithPagination.dateTo || filtersWithPagination.dateTo === '') {
                delete filtersWithPagination.dateTo;
            }
            if (!filtersWithPagination.type_operation || filtersWithPagination.type_operation === '' ||
                filtersWithPagination.type_operation === 'credit' || filtersWithPagination.type_operation === 'debit') {
                delete filtersWithPagination.type_operation;
            }
            if (!filtersWithPagination.type_transaction || filtersWithPagination.type_transaction === '') {
                delete filtersWithPagination.type_transaction;
            }
            if (!filtersWithPagination.methode_paiement || filtersWithPagination.methode_paiement === '') {
                delete filtersWithPagination.methode_paiement;
            }
            if (filtersWithPagination.categorie_id === undefined || filtersWithPagination.categorie_id === null) {
                delete filtersWithPagination.categorie_id;
            }
            if (!filtersWithPagination.statut || filtersWithPagination.statut === '') {
                delete filtersWithPagination.statut;
            }
            if (!filtersWithPagination.search || filtersWithPagination.search === '') {
                delete filtersWithPagination.search;
            }
            

            this.tresorerieService.getTresorerieListWithPagination(filtersWithPagination, currentPage, limit).subscribe({
                next: (response: any) => {
                    console.log(`📊 [DetailTresorerieComponent] Page ${currentPage} récupérée:`, response);

                    let pageOperations: Tresorerie[] = [];

                    if (response && response.success && response.data && response.data.tresoreries && Array.isArray(response.data.tresoreries)) {
                        pageOperations = response.data.tresoreries;
                    }

                    else if (response && response.data && response.data.tresoreries && Array.isArray(response.data.tresoreries)) {
                        pageOperations = response.data.tresoreries;
                    }

                    else if (Array.isArray(response) && response.length > 0 && response[0].id !== undefined) {
                        pageOperations = response;
                    }

                    else if (response && response.tresoreries && Array.isArray(response.tresoreries)) {
                        pageOperations = response.tresoreries;
                    }

                    if (pageOperations.length > 0) {
                        allOperations = [...allOperations, ...pageOperations];
                        console.log(`📄 [DetailTresorerieComponent] Page ${currentPage}: ${pageOperations.length} opérations récupérées (Total accumulé: ${allOperations.length})`);
                    }

                    let totalPages = 1;
                    if (response && response.data && response.data.pagination) {
                        totalPages = response.data.pagination.pages || 1;
                    } else if (response && response.pagination) {
                        totalPages = response.pagination.pages || 1;
                    }

                    if (currentPage < totalPages) {
                        currentPage++;
                        fetchPage();
                    } else {

                        allOperations.forEach(op => {
                            console.log(`   - ID: ${op.id}, solde_type: "${op.solde_type || 'NULL'}", type_operation: ${op.type_operation}, date: ${op.date_operation}`);
                        });

                        
                        // Filtrer par type de solde et autres filtres côté client
                        console.log('🔍 [DetailTresorerieComponent] Application des filtres côté client:', {
                            type_operation: this.filters.type_operation,
                            type_transaction: this.filters.type_transaction,
                            methode_paiement: this.filters.methode_paiement,
                            categorie_id: this.filters.categorie_id
                        });
                        
                        // Filtrer par type de solde et autres filtres côté client (sans date pour l'instant)
                        this.filteredData = allOperations.filter(op => {

                            const matchesSolde = op.solde_type === this.soldeType;

                            const matchesTypePaiement = !this.filters.type_operation || 
                                this.filters.type_operation === '' ||
                                (this.filters.type_operation !== 'credit' && this.filters.type_operation !== 'debit') ||
                                op.type_paiement === this.filters.type_operation;

                            const matchesTypeTransaction = !this.filters.type_transaction || 
                                this.filters.type_transaction === '' ||
                                op.type_operation === this.filters.type_transaction;

                            const matchesMethodePaiement = !this.filters.methode_paiement || 
                                this.filters.methode_paiement === '' ||
                                op.methode_paiement === this.filters.methode_paiement;

                            const matchesCategorie = this.filters.categorie_id === undefined || 
                                this.filters.categorie_id === null ||
                                op.categorie_id === this.filters.categorie_id;
                            
                            return matchesSolde && matchesTypePaiement && matchesTypeTransaction && matchesMethodePaiement && matchesCategorie;
                        });
                        
                        // Le filtrage de date sera appliqué dans la transformation des items
                        
                        console.log('✅ [DetailTresorerieComponent] Opérations filtrées:', this.filteredData.length, 'sur', allOperations.length);

                        this.filteredData.forEach(op => {
                            console.log(`   ✅ ID: ${op.id}, solde_type: "${op.solde_type}", type_operation: ${op.type_operation}, date: ${op.date_operation}, montant: ${op.montant}`);
                        });

                        // Transformer les données pour l'affichage
                        const itemsBeforeDateFilter = this.filteredData.map(op => ({
                            id: op.id,
                            date: this.formatDate(op.date_operation),
                            date_operation_raw: op.date_operation || null, // Stocker la date brute pour le filtrage
                            type: this.getMethodePaiementLabel(op.methode_paiement),
                            ttc: op.description || op.type_operation || '',
                            document: op.document_reference || '--',
                            debit: op.type_paiement === 'debit' ? this.formatMontant(op.montant) : '--',
                            credit: op.type_paiement === 'credit' ? this.formatMontant(op.montant) : '--',
                            operation: op
                        }));

                        // Appliquer le filtrage de date selon date_operation (selon mois et année comme les autres composants)
                        console.log(`🔍 [DetailTresorerieComponent] Avant filtrage - dateFilterStart: ${this.dateFilterStart}, dateFilterEnd: ${this.dateFilterEnd}`);
                        console.log(`🔍 [DetailTresorerieComponent] Nombre d'items avant filtrage: ${itemsBeforeDateFilter.length}`);
                        
                        this.items = itemsBeforeDateFilter.filter(item => {
                            // Si aucune date de filtre n'est définie, afficher tous les items
                            if (!this.dateFilterStart && !this.dateFilterEnd) {
                                return true;
                            }
                            
                            // Utiliser date_operation_raw qui contient la date_operation brute
                            const itemDateStr = item.date_operation_raw;
                            if (!itemDateStr) {
                                return false;
                            }
                            
                            // Parser la date_operation de l'item
                            const itemDate = this.parseDate(itemDateStr);
                            if (!itemDate || isNaN(itemDate.getTime())) {
                                return false;
                            }
                            
                            let matches = true;
                            
                            // Vérifier la date de début (début du mois ou début de l'année)
                            if (this.dateFilterStart) {
                                const dateStart = this.parseDate(this.dateFilterStart);
                                if (dateStart) {
                                    dateStart.setHours(0, 0, 0, 0);
                                    const itemDateStart = new Date(itemDate);
                                    itemDateStart.setHours(0, 0, 0, 0);
                                    // L'item doit être >= dateStart (date_operation >= dateFilterStart)
                                    if (itemDateStart < dateStart) {
                                        matches = false;
                                    }
                                }
                            }
                            
                            // Vérifier la date de fin (fin du mois ou fin de l'année)
                            if (this.dateFilterEnd && matches) {
                                const dateEnd = this.parseDate(this.dateFilterEnd);
                                if (dateEnd) {
                                    dateEnd.setHours(23, 59, 59, 999);
                                    const itemDateEnd = new Date(itemDate);
                                    itemDateEnd.setHours(23, 59, 59, 999);
                                    // L'item doit être <= dateEnd (date_operation <= dateFilterEnd)
                                    if (itemDateEnd > dateEnd) {
                                        matches = false;
                                    }
                                }
                            }
                            
                            return matches;
                        });
                        
                        console.log(`📅 [DetailTresorerieComponent] Filtrage selon date_operation appliqué: ${this.dateFilterStart} - ${this.dateFilterEnd}`);
                        console.log(`📅 [DetailTresorerieComponent] Items après filtrage de date_operation: ${this.items.length} sur ${itemsBeforeDateFilter.length}`);
                        
                        // Afficher quelques exemples d'items filtrés pour debug
                        if (this.items.length > 0 && this.items.length <= 5) {
                            this.items.forEach(item => {
                                console.log(`   ✅ Item ${item.id}: date_operation=${item.date_operation_raw}, date=${item.date}`);
                            });
                        }

                        this.items.sort((a, b) => {
                            const idA = a.id || 0;
                            const idB = b.id || 0;
                            return idB - idA; // Ordre décroissant
                        });

                        console.log('✅ [DetailTresorerieComponent] Items transformés et triés pour affichage:', this.items.length, this.items);

                        this.getActiveFilters();
                        this.isLoading = false;
                        this.updatePagination();
                    }
                },
                error: (error) => {
                    console.error('❌ [DetailTresorerieComponent] Erreur lors du chargement des opérations:', error);
                    this.toastr.error('Erreur lors du chargement des opérations.', 'Erreur');
                    this.isLoading = false;
                    this.cdr.detectChanges();
                }
            });
        };
        fetchPage();
    }

    /**
     * Parse une date au format "DD / MM / YYYY" ou autres formats
     */
    private parseDate(dateStr: string | Date): Date | null {
        if (!dateStr) return null;
        
        if (dateStr instanceof Date) {
            return isNaN(dateStr.getTime()) ? null : dateStr;
        }
        
        const dateString = String(dateStr).trim();
        if (!dateString) return null;
        
        // Format "DD / MM / YYYY" avec espaces
        const match1 = dateString.match(/(\d{1,2})\s*\/\s*(\d{1,2})\s*\/\s*(\d{4})/);
        if (match1) {
            const day = parseInt(match1[1], 10);
            const month = parseInt(match1[2], 10) - 1;
            const year = parseInt(match1[3], 10);
            const date = new Date(year, month, day);
            if (!isNaN(date.getTime())) {
                return date;
            }
        }
        
        // Format ISO "YYYY-MM-DD"
        const isoMatch = dateString.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (isoMatch) {
            const year = parseInt(isoMatch[1], 10);
            const month = parseInt(isoMatch[2], 10) - 1;
            const day = parseInt(isoMatch[3], 10);
            const date = new Date(year, month, day);
            if (!isNaN(date.getTime())) {
                return date;
            }
        }
        
        const parsed = new Date(dateString);
        if (!isNaN(parsed.getTime())) {
            return parsed;
        }
        
        return null;
    }

    private formatDate(date: string): string {
        if (!date) return '';
        const d = new Date(date);
        return `${String(d.getDate()).padStart(2, '0')}/${String(d.getMonth() + 1).padStart(2, '0')}/${d.getFullYear()}`;
    }

    private formatMontant(montant: string): string {
        if (!montant) return '0,000 TND';
        const num = parseFloat(montant);
        return `${num.toLocaleString('fr-FR', {minimumFractionDigits: 3, maximumFractionDigits: 3})} TND`;
    }

    formatSoldeMontant(): string {
        if (!this.currentSolde) {
            console.warn('💰 [DetailTresorerieComponent] formatSoldeMontant: currentSolde est null');
            return '0,000';
        }
        if (!this.currentSolde.montant_total) {
            console.warn('💰 [DetailTresorerieComponent] formatSoldeMontant: montant_total est undefined/null', this.currentSolde);
            return '0,000';
        }
        const num = parseFloat(String(this.currentSolde.montant_total));
        if (isNaN(num)) {
            console.warn('💰 [DetailTresorerieComponent] formatSoldeMontant: montant_total n\'est pas un nombre valide', this.currentSolde.montant_total);
            return '0,000';
        }
        return num.toLocaleString('fr-FR', {minimumFractionDigits: 3, maximumFractionDigits: 3});
    }

    private loadCategories(): void {
        if (!this.stationId) return;
        this.tresorerieService.getCategories(this.stationId).subscribe({
            next: (response: any) => {

                let categoriesArray: CategorieTresorerie[] = [];

                if (Array.isArray(response)) {
                    categoriesArray = response;
                } else if (response && response.data) {
                    if (Array.isArray(response.data)) {
                        categoriesArray = response.data;
                    }
                    else if (response.data.categories && Array.isArray(response.data.categories)) {
                        categoriesArray = response.data.categories;
                    }
                    else if (response.data.data && Array.isArray(response.data.data)) {
                        categoriesArray = response.data.data;
                    }
                    else if (response.data.id || response.data.nom) {
                        categoriesArray = [response.data];
                    }
                } else if (response && response.categories && Array.isArray(response.categories)) {
                    categoriesArray = response.categories;
                } else if (response && response.success && response.data) {
                    if (Array.isArray(response.data)) {
                        categoriesArray = response.data;
                    } else if (response.data.categories && Array.isArray(response.data.categories)) {
                        categoriesArray = response.data.categories;
                    } else if (response.data.id || response.data.nom) {
                        categoriesArray = [response.data];
                    }
                }

                this.categories = categoriesArray;
                this.getActiveFilters();
            },
            error: (error) => {
                console.error('Erreur lors du chargement des catégories:', error);
            }
        });
    }

    private getMethodePaiementLabel(methode: string): string {
        const labels: {[key: string]: string} = {
            'espece': 'Espèces',
            'cheque': 'Chèque',
            'virement': 'Virement',
            'traite': 'Traite'
        };
        return labels[methode] || methode;
    }

    toggleFilter() {
        this.showFilter = !this.showFilter;
    }

    onSearch() {
        this.filters.search = this.searchTerm;
        this.currentPage = 1;
        this.loadOperations();
    }

    resetFilters() {
        this.filters = {
            dateFrom: '',
            dateTo: '',
            type_operation: '',
            type_transaction: '',
            methode_paiement: '',
            categorie_id: undefined,
            statut: '',
            station_id: this.stationId,
            search: '',
            solde_type: this.soldeType
        };
        this.searchTerm = '';
        // Réinitialiser aussi les filtres de date - afficher toutes les données
        this.dateFilterStart = '';
        this.dateFilterEnd = '';
        this.currentPage = 1;
        this.getActiveFilters();
        this.loadOperations();
    }

    applyFilters() {
        // Mettre à jour les filtres actifs
        this.getActiveFilters();
        this.currentPage = 1;
        this.loadOperations();
        this.toggleFilter();
    }

    get activeFilters(): Array<{key: string, label: string, value: string}> {
        return this._activeFilters;
    }

    trackByFilterKey(index: number, filter: {key: string, label: string, value: string}): string {
        return filter.key;
    }

    getActiveFilters(): Array<{key: string, label: string, value: string}> {
        const activeFilters: Array<{key: string, label: string, value: string}> = [];
        
        if (this.filters.type_operation) {
            const typeOperationLabels: {[key: string]: string} = {
                'credit': 'Crédit',
                'debit': 'Débit',
                'depense': 'Dépense',
                'recette': 'Recette',
                'remise_banque': 'Remise en banque',
                'operation_manuelle': 'Opération manuelle',
                'avance_espece': 'Avance espèces'
            };
            activeFilters.push({
                key: 'type_operation',
                label: "Type d'opération",
                value: typeOperationLabels[this.filters.type_operation] || this.filters.type_operation
            });
        }
        
        if (this.filters.type_transaction) {
            const transactionLabels: {[key: string]: string} = {
                'paiement': 'Paiement',
                'remise_banque': 'Remise en banque',
                'operation_diverse': 'Opération diverse',
                'depense': 'Dépense',
                'annulation': 'Annulation'
            };
            activeFilters.push({
                key: 'type_transaction',
                label: 'Type de transaction',
                value: transactionLabels[this.filters.type_transaction] || this.filters.type_transaction
            });
        }
        
        if (this.filters.methode_paiement) {
            const methodeLabels: {[key: string]: string} = {
                'espece': 'Espèces',
                'cheque': 'Chèque',
                'virement': 'Virement',
                'traite': 'Traite'
            };
            activeFilters.push({
                key: 'methode_paiement',
                label: 'Mode de paiement',
                value: methodeLabels[this.filters.methode_paiement] || this.filters.methode_paiement
            });
        }
        
        if (this.filters.categorie_id !== undefined && this.filters.categorie_id !== null) {
            const categorie = this.categories.find(cat => cat.id === this.filters.categorie_id);
            activeFilters.push({
                key: 'categorie_id',
                label: 'Catégorie',
                value: categorie?.nom || `Catégorie #${this.filters.categorie_id}`
            });
        }
        
        // Ne pas afficher le filtre de date dans les boutons de filtres actifs
        // Le filtre de date est géré par le composant app-filtre-date
        
        if (this.filters.statut) {
            activeFilters.push({
                key: 'statut',
                label: 'État',
                value: this.filters.statut
            });
        }
        
        // Mettre à jour le cache
        this._activeFilters = activeFilters;
        return activeFilters;
    }

    removeFilter(filterKey: string): void {
        console.log('🗑️ [DetailTresorerieComponent] Suppression du filtre:', filterKey);
        console.log('   - Filtres avant suppression:', JSON.stringify(this.filters));

        if (filterKey === 'type_operation') {
            this.filters.type_operation = '';
        } else if (filterKey === 'type_transaction') {
            this.filters.type_transaction = '';
        } else if (filterKey === 'methode_paiement') {
            this.filters.methode_paiement = '';
        } else if (filterKey === 'categorie_id') {
            this.filters.categorie_id = undefined;
        } else if (filterKey === 'dateFrom') {
            this.filters.dateFrom = '';
        } else if (filterKey === 'dateTo') {
            this.filters.dateTo = '';
        } else if (filterKey === 'date_echeance') {
            // Réinitialiser le filtre de date - afficher toutes les données
            this.dateFilterStart = '';
            this.dateFilterEnd = '';
        } else if (filterKey === 'statut') {
            this.filters.statut = '';
        }
        
        console.log('   - Filtres après suppression:', JSON.stringify(this.filters));

        this.getActiveFilters();
        console.log('   - Filtres actifs après suppression:', this._activeFilters.length);

        this.cdr.detectChanges();

        this.currentPage = 1;
        this.loadOperations();
    }



    updatePagination() {
        this.perPage = this.basicSelectedOption;
        this.totalPages = Math.ceil(this.items.length / this.perPage);
        this.currentPage = Math.min(this.currentPage, this.totalPages || 1);
        this.pages = Array.from({length: this.totalPages}, (_, i) => i + 1);
        this.cdr.detectChanges();
    }

    changePage(page: number) {
        this.currentPage = page;
        this.updatePagination();
    }


    openSaveModal() {
        this.saveComponent.soldeType = this.soldeType;
        this.saveComponent.openModal();
    }

    /**
     * Applique le filtre de date - recharge toutes les données puis filtre côté client
     */
    private applyDateFilter(startDate: string, endDate: string): void {
        console.log(`🔄 [applyDateFilter] Application du filtre de date: ${startDate} - ${endDate}`);
        
        // Déterminer le type de filtre
        let filterType = 'Jour';
        if (startDate !== endDate) {
            const startMonth = startDate.substring(0, 7);
            const endMonth = endDate.substring(0, 7);
            if (startMonth === endMonth && startDate.substring(8, 10) === '01' && endDate.substring(8, 10) !== '01') {
                filterType = 'Mois';
            } else if (startDate.substring(5, 10) === '01-01' && endDate.substring(5, 10) === '12-31') {
                filterType = 'Année';
            }
        }
        console.log(`🔄 [applyDateFilter] Type de filtre détecté: ${filterType}`);
        
        // Mettre à jour les dates de filtre AVANT de charger les données
        this.dateFilterStart = startDate;
        this.dateFilterEnd = endDate;
        console.log(`🔄 [applyDateFilter] Dates de filtre mises à jour: dateFilterStart=${this.dateFilterStart}, dateFilterEnd=${this.dateFilterEnd}`);
        
        // Toujours recharger les données pour s'assurer qu'on a toutes les données
        // Le filtrage de date se fera côté client dans loadOperations
        this.loadOperations();
    }

    /**
     * Applique le filtre de date aux items déjà chargés
     */
    private applyDateFilterToItems(): void {
        if (!this.filteredData || this.filteredData.length === 0) {
            console.warn('⚠️ [applyDateFilterToItems] Aucune donnée à filtrer');
            return;
        }

        // Transformer les données pour l'affichage si nécessaire
        const itemsBeforeDateFilter = this.filteredData.map(op => ({
            id: op.id,
            date: this.formatDate(op.date_operation),
            date_operation_raw: op.date_operation || null,
            type: this.getMethodePaiementLabel(op.methode_paiement),
            ttc: op.description || op.type_operation || '',
            document: op.document_reference || '--',
            debit: op.type_paiement === 'debit' ? this.formatMontant(op.montant) : '--',
            credit: op.type_paiement === 'credit' ? this.formatMontant(op.montant) : '--',
            operation: op
        }));

        // Appliquer le filtrage de date selon date_operation
        this.items = itemsBeforeDateFilter.filter(item => {
            if (!this.dateFilterStart && !this.dateFilterEnd) {
                return true;
            }
            
            const itemDateStr = item.date_operation_raw;
            if (!itemDateStr) return false;
            
            const itemDate = this.parseDate(itemDateStr);
            if (!itemDate || isNaN(itemDate.getTime())) {
                return false;
            }
            
            let matches = true;
            
            if (this.dateFilterStart) {
                const dateStart = this.parseDate(this.dateFilterStart);
                if (dateStart) {
                    dateStart.setHours(0, 0, 0, 0);
                    const itemDateStart = new Date(itemDate);
                    itemDateStart.setHours(0, 0, 0, 0);
                    if (itemDateStart < dateStart) {
                        matches = false;
                    }
                }
            }
            
            if (this.dateFilterEnd && matches) {
                const dateEnd = this.parseDate(this.dateFilterEnd);
                if (dateEnd) {
                    dateEnd.setHours(23, 59, 59, 999);
                    const itemDateEnd = new Date(itemDate);
                    itemDateEnd.setHours(23, 59, 59, 999);
                    if (itemDateEnd > dateEnd) {
                        matches = false;
                    }
                }
            }
            
            return matches;
        });

        this.items.sort((a, b) => {
            const idA = a.id || 0;
            const idB = b.id || 0;
            return idB - idA;
        });

        console.log(`📅 [applyDateFilterToItems] Filtrage selon date_operation appliqué: ${this.dateFilterStart} - ${this.dateFilterEnd}`);
        console.log(`📅 [applyDateFilterToItems] Items après filtrage: ${this.items.length} sur ${itemsBeforeDateFilter.length}`);
        
        this.updatePagination();
        this.cdr.detectChanges();
    }

    /**
     * Écoute les changements de date depuis le composant app-filtre-date
     */
    onDateFilterChange(event: {startDate: string, endDate: string}): void {
        console.log(`🔄 [onDateFilterChange] Changement de date depuis app-filtre-date: ${event.startDate} - ${event.endDate}`);
        this.applyDateFilter(event.startDate, event.endDate);
    }

    exportToXML(): void {
        try {
            const xmlData = this.prepareXMLData();
            const xmlContent = this.generateXML(xmlData);
            const blob = new Blob([xmlContent], { type: 'application/xml;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            const date = new Date().toISOString().split('T')[0];
            const soldeTypeLabel = this.soldeType === 'primaire' ? 'solde-primaire' : 'solde-secondaire';
            const filename = `detail-tresorerie-${soldeTypeLabel}-${date}.xml`;
            link.setAttribute('href', url);
            link.setAttribute('download', filename);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            this.toastr.success(`XML "${filename}" téléchargé avec succès !`, 'Succès');
        } catch (error: any) {
            console.error('Erreur lors de la génération du XML:', error);
            this.toastr.error(`Erreur lors de la génération du XML: ${error?.message || 'Erreur inconnue'}`, 'Erreur');
        }
    }

    private prepareXMLData(): any {
        const soldeTypeLabel = this.soldeTypeTitreForExport();
        const soldeMontant = this.currentSolde ? parseFloat(String(this.currentSolde.montant_total)) : 0;

        return {
            titre: soldeTypeLabel,
            date_export: new Date().toISOString(),
            solde: {
                type: this.soldeType,
                montant_total: soldeMontant.toFixed(3)
            },
            operations: this.items.map(item => ({
                id: item.id,
                date: item.date,
                type: item.type,
                description: item.ttc,
                document: item.document,
                debit: item.debit !== '--' ? item.debit.replace(' TND', '').replace(/\s/g, '') : '0,000',
                credit: item.credit !== '--' ? item.credit.replace(' TND', '').replace(/\s/g, '') : '0,000',
                operation: {
                    id: item.operation?.id,
                    date_operation: item.operation?.date_operation,
                    type_operation: item.operation?.type_operation,
                    type_paiement: item.operation?.type_paiement,
                    methode_paiement: item.operation?.methode_paiement,
                    montant: item.operation?.montant,
                    description: item.operation?.description,
                    document_reference: item.operation?.document_reference
                }
            }))
        };
    }

    private generateXML(data: any): string {
        let xml = '<?xml version="1.0" encoding="UTF-8"?>\n';
        xml += '<tresorerie>\n';
        xml += `  <titre>${this.escapeXML(data.titre)}</titre>\n`;
        xml += `  <date_export>${this.escapeXML(data.date_export)}</date_export>\n`;
        xml += '  <solde>\n';
        xml += `    <type>${this.escapeXML(data.solde.type)}</type>\n`;
        xml += `    <montant_total>${this.escapeXML(data.solde.montant_total)}</montant_total>\n`;
        xml += '  </solde>\n';
        xml += '  <operations>\n';

        data.operations.forEach((op: any) => {
            xml += '    <operation>\n';
            xml += `      <id>${op.id || ''}</id>\n`;
            xml += `      <date>${this.escapeXML(op.date)}</date>\n`;
            xml += `      <type>${this.escapeXML(op.type)}</type>\n`;
            xml += `      <description>${this.escapeXML(op.description)}</description>\n`;
            xml += `      <document>${this.escapeXML(op.document)}</document>\n`;
            xml += `      <debit>${this.escapeXML(op.debit)}</debit>\n`;
            xml += `      <credit>${this.escapeXML(op.credit)}</credit>\n`;
            if (op.operation) {
                xml += '      <details>\n';
                xml += `        <id>${op.operation.id || ''}</id>\n`;
                xml += `        <date_operation>${this.escapeXML(op.operation.date_operation || '')}</date_operation>\n`;
                xml += `        <type_operation>${this.escapeXML(op.operation.type_operation || '')}</type_operation>\n`;
                xml += `        <type_paiement>${this.escapeXML(op.operation.type_paiement || '')}</type_paiement>\n`;
                xml += `        <methode_paiement>${this.escapeXML(op.operation.methode_paiement || '')}</methode_paiement>\n`;
                xml += `        <montant>${this.escapeXML(op.operation.montant || '')}</montant>\n`;
                xml += `        <description>${this.escapeXML(op.operation.description || '')}</description>\n`;
                xml += `        <document_reference>${this.escapeXML(op.operation.document_reference || '')}</document_reference>\n`;
                xml += '      </details>\n';
            }
            xml += '    </operation>\n';
        });

        xml += '  </operations>\n';
        xml += '</tresorerie>';

        return xml;
    }

    private escapeXML(str: string): string {
        if (!str) return '';
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&apos;');
    }

    async exportToPDF(): Promise<void> {
        try {
            this.toastr.info('Génération du PDF en cours...', '', { timeOut: 2000 });
            await new Promise(resolve => setTimeout(resolve, 500));

            let cardElement: HTMLElement | null = null;
            if (this.exportContainer && this.exportContainer.nativeElement) {
                cardElement = this.exportContainer.nativeElement;
            } else {
                cardElement = document.querySelector('.card') as HTMLElement;
            }

            if (!cardElement) {
                this.toastr.error('Élément à exporter introuvable.', 'Erreur');
                return;
            }

            const originalPerPage = this.perPage;
            const originalCurrentPage = this.currentPage;
            const totalItems = this.items.length;
            if (totalItems > 0) {
                this.perPage = totalItems;
                this.currentPage = 1;
                this.updatePagination();
                this.cdr.detectChanges();
                await new Promise(resolve => setTimeout(resolve, 500));
            } else {
                await new Promise(resolve => setTimeout(resolve, 300));
            }
            const elementsToHide = [
                ...Array.from(cardElement.querySelectorAll('app-title-section')),
                ...Array.from(cardElement.querySelectorAll('.p-1.mt-1')),
                ...Array.from(cardElement.querySelectorAll('.d-flex[style*="margin-top: 24px"]')),
                ...Array.from(cardElement.querySelectorAll('.filter-sidebar')),
                ...Array.from(cardElement.querySelectorAll('.row.mt-3')),
                ...Array.from(cardElement.querySelectorAll('.action-icon'))
            ];

            const originalDisplays: string[] = [];
            const originalVisibilities: string[] = [];

            elementsToHide.forEach((el) => {
                const htmlEl = el as HTMLElement;
                originalDisplays.push(htmlEl.style.display || '');
                originalVisibilities.push(htmlEl.style.visibility || '');
                htmlEl.style.display = 'none';
                htmlEl.style.visibility = 'hidden';
            });
            const dateFilterElement = cardElement.querySelector('.date-filter-container') as HTMLElement;
            const dateFilterHeader = cardElement.querySelector('.date-filter-header') as HTMLElement;
            const dateFilterButtons = cardElement.querySelector('.date-filter-buttons') as HTMLElement;
            const dataListElements = cardElement.querySelectorAll('.data-list') as NodeListOf<HTMLElement>;
            const tableElement = cardElement.querySelector('.table-responsive') as HTMLElement;
            const cardBlueElement = cardElement.querySelector('.cardBlue') as HTMLElement;
            if (dateFilterElement) {
                dateFilterElement.style.display = 'flex';
                dateFilterElement.style.visibility = 'visible';
                dateFilterElement.style.justifyContent = 'space-between';
                dateFilterElement.style.alignItems = 'center';
                dateFilterElement.style.padding = '28px 24px';
            }

            if (dateFilterHeader) {
                dateFilterHeader.style.display = 'flex';
                dateFilterHeader.style.alignItems = 'center';
                dateFilterHeader.style.justifyContent = 'start';
                dateFilterHeader.style.gap = '2px';
                dateFilterHeader.style.width = '100%';
            }

            if (dateFilterButtons) {
                dateFilterButtons.style.display = 'flex';
                dateFilterButtons.style.alignItems = 'center';
                dateFilterButtons.style.gap = '10px';
            }

            dataListElements.forEach(dataList => {
                dataList.style.display = 'block';
                dataList.style.visibility = 'visible';
            });
            let originalCardBlueStyles: { [key: string]: string } = {};
            if (cardBlueElement) {
                originalCardBlueStyles = {
                    position: cardBlueElement.style.position || '',
                    top: cardBlueElement.style.top || '',
                    marginTop: cardBlueElement.style.marginTop || '',
                    marginBottom: cardBlueElement.style.marginBottom || '',
                    display: cardBlueElement.style.display || '',
                    visibility: cardBlueElement.style.visibility || '',
                    flexDirection: cardBlueElement.style.flexDirection || '',
                    justifyContent: cardBlueElement.style.justifyContent || '',
                    alignItems: cardBlueElement.style.alignItems || ''
                };
                cardBlueElement.style.display = 'flex';
                cardBlueElement.style.visibility = 'visible';
                cardBlueElement.style.position = 'relative';
                cardBlueElement.style.marginTop = '0';
                cardBlueElement.style.marginBottom = '0';
                cardBlueElement.style.flexDirection = 'row';
                cardBlueElement.style.justifyContent = 'space-between';
                cardBlueElement.style.alignItems = 'center';
            }

            if (tableElement) {
                tableElement.style.display = 'block';
                tableElement.style.visibility = 'visible';
            }
            await new Promise(resolve => setTimeout(resolve, 200));
            const canvas = await html2canvas(cardElement, {
                scale: 2,
                useCORS: true,
                backgroundColor: '#ffffff',
                width: cardElement.scrollWidth,
                height: cardElement.scrollHeight,
                logging: false,
                allowTaint: true,
                scrollX: 0,
                scrollY: 0,
                windowWidth: cardElement.scrollWidth,
                windowHeight: cardElement.scrollHeight,
                onclone: (clonedDoc) => {
                    const overlays = clonedDoc.querySelectorAll(
                        'app-title-section, .p-1.mt-1, .d-flex[style*="margin-top: 24px"], .filter-sidebar, .row.mt-3, .action-icon'
                    );
                    overlays.forEach(overlay => {
                        (overlay as HTMLElement).style.display = 'none';
                        (overlay as HTMLElement).style.visibility = 'hidden';
                    });
                    const clonedDateFilter = clonedDoc.querySelector('.date-filter-container') as HTMLElement;
                    const clonedDateFilterHeader = clonedDoc.querySelector('.date-filter-header') as HTMLElement;
                    const clonedDateFilterButtons = clonedDoc.querySelector('.date-filter-buttons') as HTMLElement;
                    const clonedDataList = clonedDoc.querySelectorAll('.data-list') as NodeListOf<HTMLElement>;

                    if (clonedDateFilter) {
                        clonedDateFilter.style.display = 'flex';
                        clonedDateFilter.style.visibility = 'visible';
                        clonedDateFilter.style.justifyContent = 'space-between';
                        clonedDateFilter.style.alignItems = 'center';
                        clonedDateFilter.style.padding = '28px 24px';
                    }

                    if (clonedDateFilterHeader) {
                        clonedDateFilterHeader.style.display = 'flex';
                        clonedDateFilterHeader.style.alignItems = 'center';
                        clonedDateFilterHeader.style.justifyContent = 'start';
                        clonedDateFilterHeader.style.gap = '2px';
                        clonedDateFilterHeader.style.width = '100%';
                    }

                    if (clonedDateFilterButtons) {
                        clonedDateFilterButtons.style.display = 'flex';
                        clonedDateFilterButtons.style.alignItems = 'center';
                        clonedDateFilterButtons.style.gap = '10px';
                    }

                    clonedDataList.forEach(dataList => {
                        dataList.style.display = 'block';
                        dataList.style.visibility = 'visible';
                    });
                    const clonedTable = clonedDoc.querySelector('.table-responsive') as HTMLElement;
                    const clonedCardBlue = clonedDoc.querySelector('.cardBlue') as HTMLElement;

                    if (clonedTable) {
                        clonedTable.style.display = 'block';
                        clonedTable.style.visibility = 'visible';
                    }
                    if (clonedCardBlue) {
                        clonedCardBlue.style.display = 'flex';
                        clonedCardBlue.style.visibility = 'visible';
                        clonedCardBlue.style.position = 'relative';
                        clonedCardBlue.style.marginTop = '0';
                        clonedCardBlue.style.marginBottom = '0';
                        clonedCardBlue.style.flexDirection = 'row';
                        clonedCardBlue.style.justifyContent = 'space-between';
                        clonedCardBlue.style.alignItems = 'center';
                    }
                }
            });
            elementsToHide.forEach((el, index) => {
                (el as HTMLElement).style.display = originalDisplays[index] || '';
                (el as HTMLElement).style.visibility = originalVisibilities[index] || '';
            });
            if (cardBlueElement && Object.keys(originalCardBlueStyles).length > 0) {
                Object.keys(originalCardBlueStyles).forEach(key => {
                    const value = originalCardBlueStyles[key];
                    if (value) {
                        (cardBlueElement.style as any)[key] = value;
                    } else {
                        (cardBlueElement.style as any).removeProperty(key);
                    }
                });
            }
            this.perPage = originalPerPage;
            this.currentPage = originalCurrentPage;
            this.updatePagination();
            this.cdr.detectChanges();
            if (canvas.width === 0 || canvas.height === 0) {
                this.toastr.error('Le contenu à exporter est vide.', 'Erreur');
                return;
            }
            const imgData = canvas.toDataURL('image/png');
            const pdf = new jsPDF('p', 'mm', 'a4');

            const imgWidth = 210;
            const pageHeight = 297;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;
            let heightLeft = imgHeight;
            let position = 0;
            pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
            heightLeft -= pageHeight;
            while (heightLeft >= 0) {
                position = heightLeft - imgHeight;
                pdf.addPage();
                pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
                heightLeft -= pageHeight;
            }
            const date = new Date().toISOString().split('T')[0];
            const soldeTypeLabel = this.soldeTypeSlugForFile();
            const filename = `detail-tresorerie-${soldeTypeLabel}-${date}.pdf`;
            pdf.save(filename);
            this.toastr.success(`PDF "${filename}" téléchargé avec succès !`, 'Succès');

        } catch (error: any) {
            this.toastr.error(`Erreur lors de la génération du PDF: ${error?.message || 'Erreur inconnue'}`, 'Erreur');
        }
    }

}
